import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class WebsocketConfig {
  socketId: string | undefined = '';
}
